<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSecurityGroupListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../ecr/TableExpand.vue";
var tableSecurityGroupVue = {};
export default {
  name: "TableEcr",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("permission_configuration_management.account.accountId"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.ECR.repositoryName"),
          key: "repositoryName"
        },
        {
          title: 'URI',
          key: "repositoryUri"
        },
        {
          title: this.$t("operation_log.createdTime"),
          key: "creationAt"
        },
        {
          title: this.$t("RAM.AWS.ECR.labelInvariance"),
          key: "imageTagMutabilityName"
        },
        {
          title: this.$t("RAM.AWS.ECR.pushScan"),
          key: "imageScanningConfigurationName"
        },
        {
          title: this.$t("RAM.AWS.ECR.encryptionType"),
          key: 'encryptionConfigurationName'
        }
      ],
      tableSecurityGroupListData: []
    };
  },
  beforeCreate: function() {
    tableSecurityGroupVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountName", function(val) {
      tableSecurityGroupVue.accountName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableSecurityGroupVue.companyId = val;
    });
    eventBus.$on("repositoryName", function(val) {
      tableSecurityGroupVue.repositoryName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 分页显示数据
    /****************************************************/
    getSecurityGroupListData: function() {
      var pageSecurityGroupDate = {
        pageNum: this.current,
        pageSize: this.pageSize,
        accountName: tableSecurityGroupVue.accountName,
        companyId: tableSecurityGroupVue.companyId,
        repositoryName: tableSecurityGroupVue.repositoryName
      };
      this.$api.cmdb
        .pagingQueryAWSEcr(pageSecurityGroupDate)
        .then(res => {
          this.tableSecurityGroupListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 销毁caseSearchID
    beforeDestroy: function() {
      eventBus.$off("accountName");
      eventBus.$off("companyId");
      eventBus.$off("repositoryName");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ecr/TableECR.vue